import Component from '@glimmer/component';

import { concat } from '@ember/helper';

import dateTime from 'rise-ui/helpers/date-time.js';
import isUnset from 'rise-ui/helpers/is-unset.js';
import localeNum from 'rise-ui/helpers/locale-num.js';
import parameterUnit from 'rise-ui/helpers/parameter-unit.js';

export default class TimeSeriesOutputLineLegendTooltipComponent extends Component {
  <template>
    {{#if @tooltip}}
      <div ...attributes>
        <span>{{dateTime @tooltip.date}}</span>
        |
        <span>
          {{if (isUnset @tooltip.value)
            "null"
            (concat (localeNum @tooltip.value) " " (parameterUnit @parameterUnit))
          }}
        </span>
      </div>
    {{/if}}
  </template>
}
